import type { RouteRecordRaw } from 'vue-router';
import { Layout } from '@/core/layout/layout';

const ScenarioPage = () => import('./components/ScenarioPage.vue');

export enum ProcessDetailsRoute {
    CurrentStep = 'process_details:current_step',
    Documents = 'process_details:documents',
    Details = 'process_details:details',
}

/**
 * Route name of the legacy process view. Preserved because absolute URLs built from
 * it are held outside this repository — the backend stores one as a payment return
 * link, and sent mail carries others. See
 * `docs/adr/0019-process-details-view-mounts-under-incorporation-id.md`.
 */
export const LEGACY_PROCESS_VIEW_ROUTE = 'incorporation';

/** Query parameter that opens the messages drawer on load. */
export const MESSAGES_QUERY = 'messages';

/**
 * The tab routes of the process details view, plus the `messages` redirect. Mounted as children of
 * `/incorporation/:id` by `incorporation.router.ts`, alongside the legacy view, with
 * `ProcessViewResolver` deciding which of the two renders. Every tab renders `ScenarioPage`,
 * which shows the page the current scenario provides for it (see `use-scenario-pages.ts`).
 */
export const processDetailsRoutes: RouteRecordRaw[] = [
    {
        path: 'current-step',
        name: ProcessDetailsRoute.CurrentStep,
        component: ScenarioPage,
        meta: { layout: Layout.Blank },
    },
    // Messages show in a drawer, not a tab. The path stays because sent mail links to it.
    {
        path: 'messages',
        redirect: (to) => ({ name: ProcessDetailsRoute.CurrentStep, params: to.params, query: { ...to.query, [MESSAGES_QUERY]: null } }),
    },
    {
        path: 'documents',
        name: ProcessDetailsRoute.Documents,
        component: ScenarioPage,
        meta: { layout: Layout.Blank },
    },
    {
        path: 'details',
        name: ProcessDetailsRoute.Details,
        component: ScenarioPage,
        meta: { layout: Layout.Blank },
    },
];
